import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import Loading from "../Loading";
import ServerList from "../server/ServerList";
import ServerEditor from "../server/ServerEditor";
import UserList from "./UserList";
import UserEditor from "./UserEditor";


interface Props {

}

export default function Users({}: Props) {
    const [selectedServer, setselectedServer] = useState<string | null>(null);
    const [searchParameters, setSearchParameters] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        if (searchParameters.has('user')) {
            const user = searchParameters.get('user');
            if (user) {
                setselectedServer(user);
                setLoading(false);
            } else {
                setselectedServer(null);
                setLoading(false);
            }
        }else{
            setselectedServer(null);
            setLoading(false);
        }
    }, [searchParameters]);

    return (<>
        <Loading open={loading}></Loading>
        {!loading && !selectedServer && (<UserList></UserList>)}
        {!loading && selectedServer && (<UserEditor userId={selectedServer}></UserEditor>)}
    </>);
}